import { SR_API_ACTION_ACCOUNT_MANAGER_GET_LIST } from 'api/actionTypes';

export default async function getList({ state, apiClient }) {
  const statePath = ['accountManagers', 'list'];

  await apiClient.postWithState({
    action: SR_API_ACTION_ACCOUNT_MANAGER_GET_LIST,
    state: state,
    onSuccess(leasingManagers) {
      state.set(statePath, leasingManagers);
    },
  });
}
